// extracted by mini-css-extract-plugin
export default {"table-container":"lsLirBphrXP37DoOn8OK","table-wrapper":"rdQR66dSFVTgh2FPEvfe"};